import { Action } from '@ngrx/store';

export enum ProjectActionTypes {
  GET_PROJECT = '[Project] GET',
  GET_PROJECT_SUCCESS = '[Project] GET Success',
  GET_PROJECT_FAILURE = '[Project] GET Failure',

  GET_PROJECTS = '[Projects] GET',
  GET_PROJECTS_SUCCESS = '[Projects] GET Success',
  GET_PROJECTS_FAILURE = '[Projects] GET Failure',

  // PROJECT OFFER ACTIONS
  ASSIGN_OFFER = '[Project] ASSIGN Offer',
  ASSIGN_OFFER_SUCCESS = '[Project] ASSIGN Offer Success',

  SET_PROJECT = '[Project] SET Project',
  SET_PROJECT_SUCCESS = '[Project] SET Project Success',
  SET_PROJECT_FAILURE = '[Project] SET Project Failure',

  EDIT_PROJECT = '[Project] EDIT Project',
  COPY_PROJECT = '[Project] COPY Project',
  SHOW_PROJECT_INFO = '[Project] SHOW Info Project',
  SHOW_COPY_PROJECT = '[Project] SHOW Copy Project',
  SHOW_ARRANGE_PAGES = '[Project] SHOW Arrange Pages',
  //EDIT_PROJECT_SUCCESS = '[Project] EDIT Project Success',

  CREATE_PROJECT = '[Project] CREATE Project',
  UPDATE_PROJECT = '[Project] UPDATE Project',
  UPDATE_PROJECT_SUCCESS = '[Project] UPDATE Project Success',
  UPDATE_PROJECT_FAILURE = '[Project] UPDATE Project Failure',

  RETIRE_PROJECT = '[Project] Retire Project',
  RETIRE_PROJECT_SUCCESS = '[Project] Retire Project Success',
  RETIRE_PROJECT_FAILURE = '[Project] Retire Project Failure',

  RESTORE_PROJECT = '[Project] Restore Project',
  RESTORE_PROJECT_SUCCESS = '[Project] Restore Project Success',
  RESTORE_PROJECT_FAILURE = '[Project] Restore Project Failure',

  GET_PERSONS = '[Projects] GET Persons',
  GET_PERSONS_SUCCESS = '[Projects] GET Persons Success',
  GET_PERSONS_FAILURE = '[Projects] GET Persons Failure',

  GET_DOCUMENT_SUB_TYPES = '[Projects] GET Document Sub Types',
  GET_DOCUMENT_SUB_TYPES_SUCCESS = '[Projects] GET Document Sub Types Success',
  GET_DOCUMENT_SUB_TYPES_FAILURE = '[Projects] GET Document Sub Types Failure',

  GET_PAGE_LAYOUTS = '[Projects] GET Page Layouts',
  GET_PAGE_LAYOUTS_SUCCESS = '[Projects] GET Page Layouts Success',
  GET_PAGE_LAYOUTS_FAILURE = '[Projects] GET Page Layouts Failure',

  GET_MASTER_REGION_TEMPLATES = '[Projects] GET Master Region Templates',
  GET_MASTER_REGION_TEMPLATES_SUCCESS = '[Projects] GET Master Region Templates Success',
  GET_MASTER_REGION_TEMPLATES_FAILURE = '[Projects] GET Master Region Templates Failure',

  GET_PAGE_BACKGROUNDS = '[Projects] GET Page Backgrounds',
  GET_PAGE_BACKGROUNDS_SUCCESS = '[Projects] GET Page Backgrounds Success',
  GET_PAGE_BACKGROUNDS_FAILURE = '[Projects] GET Page Backgrounds Failure',

  GET_BUSINESS_BRANDS = '[Projects] GET Business Brands',
  GET_BUSINESS_BRANDS_SUCCESS = '[Projects] GET Business Brands Success',
  GET_BUSINESS_BRANDS_FAILURE = '[Projects] GET Business Brands Failure',

  GENERATE_PROJECT_CSV = '[Project] GENERATE Project CSV',
  GENERATE_PROJECT_CSV_SUCCESS = '[Project] GENERATE Project CSV Success',
  GENERATE_PROJECT_CSV_FAILURE = '[Project] GENERATE Project CSV Failure',

  VALIDATE_PROJECT = '[Projects] VALIDATE Project',
  VALIDATE_PROJECT_SUCCESS = '[Projects] VALIDATE Project Success',
  VALIDATE_PROJECT_FAILURE = '[Projects] VALIDATE Project Failure',

  GET_STUDIO_PREF = '[Projects] GET Studio Pref',		
  GET_STUDIO_PREF_SUCCESS = '[Projects] GET Studio Pref Success',		
  GET_STUDIO_PREF_FAILURE = '[Projects] GET Studio Pref Failure',

  GET_STUDIOS = '[Projects] GET Studios',
  GET_STUDIOS_SUCCESS = '[Projects] GET Studios Success',
  GET_STUDIOS_FAILURE = '[Projects] GET Studios Failure',

  ASSIGN_STUDIOS_TO_JOB = '[Projects] ASSIGN Studios to Job',
  ASSIGN_STUDIOS_TO_JOB_SUCCESS = '[Projects] ASSIGN Studios to Job Success',
  ASSIGN_STUDIOS_TO_JOB_FAILURE = '[Projects] ASSIGN Studios to Job Failure',

  ASSIGN_STUDIOS_TO_PAGE = '[Projects] ASSIGN Studios to Page',
  ASSIGN_STUDIOS_TO_PAGE_SUCCESS = '[Projects] ASSIGN Studios to Page Success',
  ASSIGN_STUDIOS_TO_PAGE_FAILURE = '[Projects] ASSIGN Studios to Page Failure',

  ASSIGN_STUDIOS_TO_PAGES = '[Projects] ASSIGN Studios to Pages',
  ASSIGN_STUDIOS_TO_PAGES_SUCCESS = '[Projects] ASSIGN Studios to Pages Success',
  ASSIGN_STUDIOS_TO_PAGES_FAILURE = '[Projects] ASSIGN Studios to Pages Failure',

  SEND_PAGES_TO_STUDIO = '[Projects] SEND Pages to Studio',
  SEND_PAGES_TO_STUDIO_SUCCESS = '[Projects] SEND Pages to Studio Success',
  SEND_PAGES_TO_STUDIO_FAILURE = '[Projects] SEND Pages to Studio Failure',

  SEND_MANY_PAGES_TO_STUDIO = '[Projects] SEND Many Pages to Studio',
  SEND_MANY_PAGES_TO_STUDIO_SUCCESS = '[Projects] SEND Many Pages to Studio Success',
  SEND_MANY_PAGES_TO_STUDIO_FAILURE = '[Projects] SEND Many Pages to Studio Failure',

}

// PROJECTS
export class GetProjects implements Action {
  readonly type = ProjectActionTypes.GET_PROJECTS;
  constructor(public payload: any) {}
}
export class GetProjectsSuccess implements Action {
  readonly type = ProjectActionTypes.GET_PROJECTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetProjectsFailure implements Action {
  readonly type = ProjectActionTypes.GET_PROJECTS_FAILURE;
  constructor(public payload: any) {}
}

// GET SINGLE PROJECT
export class GetProject implements Action {
  readonly type = ProjectActionTypes.GET_PROJECT;
  constructor(public payload: any) {}
}
export class GetProjectSuccess implements Action {
  readonly type = ProjectActionTypes.GET_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class GetProjectFailure implements Action {
  readonly type = ProjectActionTypes.GET_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

// PROJECT
export class EditProject implements Action {
  readonly type = ProjectActionTypes.EDIT_PROJECT;
  constructor(public payload: any) {}
}
// export class EditProjectSuccess implements Action {
//   readonly type = ProjectActionTypes.EDIT_PROJECT_SUCCESS;
//   constructor(public payload: any) {}
// }

export class CreateProject implements Action {
  readonly type = ProjectActionTypes.CREATE_PROJECT;
  constructor(public payload: any) {}
}
export class SetProject implements Action {
  readonly type = ProjectActionTypes.SET_PROJECT;
  constructor(public payload: any) {}
}
export class SetProjectSuccess implements Action {
  readonly type = ProjectActionTypes.SET_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class SetProjectFailure implements Action {
  readonly type = ProjectActionTypes.SET_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

export class ShowProjectInfo implements Action {
  readonly type = ProjectActionTypes.SHOW_PROJECT_INFO;
  constructor(public payload: any) {}
}
export class ShowCopyProject implements Action {
  readonly type = ProjectActionTypes.SHOW_COPY_PROJECT;
  constructor(public payload: any) {}
}

export class ShowArrangePages implements Action {
  readonly type = ProjectActionTypes.SHOW_ARRANGE_PAGES;
  constructor(public payload: any) {}
}

export class UpdateProject implements Action {
  readonly type = ProjectActionTypes.UPDATE_PROJECT;
  constructor(public payload: any) {}
}
export class UpdateProjectSuccess implements Action {
  readonly type = ProjectActionTypes.UPDATE_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateProjectFailure implements Action {
  readonly type = ProjectActionTypes.UPDATE_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

export class RetireProject implements Action {
  readonly type = ProjectActionTypes.RETIRE_PROJECT;
  constructor(public payload: any) {}
}

export class RetireProjectSuccess implements Action {
  readonly type = ProjectActionTypes.RETIRE_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}

export class RetireProjectFailure implements Action {
  readonly type = ProjectActionTypes.RETIRE_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

export class RestoreProject implements Action {
  readonly type = ProjectActionTypes.RESTORE_PROJECT;
  constructor(public payload: any) {}
}

export class RestoreProjectSuccess implements Action {
  readonly type = ProjectActionTypes.RESTORE_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}

export class RestoreProjectFailure implements Action {
  readonly type = ProjectActionTypes.RESTORE_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

// OFFERS
export class AssignOffer implements Action {
  readonly type = ProjectActionTypes.ASSIGN_OFFER;
  constructor(public payload: any) {}
}
export class AssignOfferSuccess implements Action {
  readonly type = ProjectActionTypes.ASSIGN_OFFER_SUCCESS;
  constructor(public payload: any) {}
}

// PERSONS
export class GetPersons implements Action {
  readonly type = ProjectActionTypes.GET_PERSONS;
  constructor(public payload: any) {}
}
export class GetPersonsSuccess implements Action {
  readonly type = ProjectActionTypes.GET_PERSONS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPersonsFailure implements Action {
  readonly type = ProjectActionTypes.GET_PERSONS_FAILURE;
  constructor(public payload: any) {}
}

// DOCUMENT SUBTYPES
export class GetDocumentSubTypes implements Action {
  readonly type = ProjectActionTypes.GET_DOCUMENT_SUB_TYPES;
  constructor(public payload: any) {}
}
export class GetDocumentSubTypesSuccess implements Action {
  readonly type = ProjectActionTypes.GET_DOCUMENT_SUB_TYPES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetDocumentSubTypesFailure implements Action {
  readonly type = ProjectActionTypes.GET_DOCUMENT_SUB_TYPES_FAILURE;
  constructor(public payload: any) {}
}

// PAGE LAYOUTS
export class GetPageLayouts implements Action {
  readonly type = ProjectActionTypes.GET_PAGE_LAYOUTS;
  constructor(public payload: any) {}
}
export class GetPageLayoutsSuccess implements Action {
  readonly type = ProjectActionTypes.GET_PAGE_LAYOUTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageLayoutsFailure implements Action {
  readonly type = ProjectActionTypes.GET_PAGE_LAYOUTS_FAILURE;
  constructor(public payload: any) {}
}

// Master Region Templates
export class GetMasterRegionTemplates implements Action {
  readonly type = ProjectActionTypes.GET_MASTER_REGION_TEMPLATES;
  constructor(public payload: any) {}
}
export class GetMasterRegionTemplatesSuccess implements Action {
  readonly type = ProjectActionTypes.GET_MASTER_REGION_TEMPLATES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetMasterRegionTemplatesFailure implements Action {
  readonly type = ProjectActionTypes.GET_MASTER_REGION_TEMPLATES_FAILURE;
  constructor(public payload: any) {}
}

// Page Backgrounds
export class GetPageBackgrounds implements Action {
  readonly type = ProjectActionTypes.GET_PAGE_BACKGROUNDS;
  constructor(public payload: any) {}
}
export class GetPageBackgroundsSuccess implements Action {
  readonly type = ProjectActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageBackgroundsFailure implements Action {
  readonly type = ProjectActionTypes.GET_PAGE_BACKGROUNDS_FAILURE;
  constructor(public payload: any) {}
}

// Page Business Brands
export class GetBusinessBrands implements Action {
  readonly type = ProjectActionTypes.GET_BUSINESS_BRANDS;
  constructor(public payload: any) {}
}
export class GetBusinessBrandsSuccess implements Action {
  readonly type = ProjectActionTypes.GET_BUSINESS_BRANDS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetBusinessBrandsFailure implements Action {
  readonly type = ProjectActionTypes.GET_BUSINESS_BRANDS_FAILURE;
  constructor(public payload: any) {}
}


// Project csv
export class GenerateProjectCSV implements Action {
  readonly type = ProjectActionTypes.GENERATE_PROJECT_CSV;
  constructor(public payload: any) {}
}
export class GenerateProjectCSVSuccess implements Action {
  readonly type = ProjectActionTypes.GENERATE_PROJECT_CSV_SUCCESS;
  constructor(public payload: any) {}
}
export class GenerateProjectCSVFailure implements Action {
  readonly type = ProjectActionTypes.GENERATE_PROJECT_CSV_FAILURE;
  constructor(public payload: any) {}
}

// Validate Project
export class ValidateProject implements Action {
  readonly type = ProjectActionTypes.VALIDATE_PROJECT;
  constructor(public payload: any) {}
}
export class ValidateProjectSuccess implements Action {
  readonly type = ProjectActionTypes.VALIDATE_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class ValidateProjectFailure implements Action {
  readonly type = ProjectActionTypes.VALIDATE_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

// STUDIOS
export class GetStudioPref implements Action {		
  readonly type = ProjectActionTypes.GET_STUDIO_PREF;		
  constructor(public payload: any) {}		
}		
export class GetStudioPrefSuccess implements Action {		
  readonly type = ProjectActionTypes.GET_STUDIO_PREF_SUCCESS;		
  constructor(public payload: any) {}		
}		
export class GetStudioPrefFailure implements Action {		
  readonly type = ProjectActionTypes.GET_STUDIO_PREF_FAILURE;		
  constructor(public payload: any) {}		
}

export class GetStudios implements Action {
  readonly type = ProjectActionTypes.GET_STUDIOS;
  constructor(public payload: any) {}
}
export class GetStudiosSuccess implements Action {
  readonly type = ProjectActionTypes.GET_STUDIOS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetStudiosFailure implements Action {
  readonly type = ProjectActionTypes.GET_STUDIOS_FAILURE;
  constructor(public payload: any) {}
}

export class AssignStudiosToJob implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB;
  constructor(public payload: any) {}
}
export class AssignStudiosToJobSuccess implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignStudiosToJobFailure implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB_FAILURE;
  constructor(public payload: any) {}
}

export class AssignStudiosToPage implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE;
  constructor(public payload: any) {}
}
export class AssignStudiosToPageSuccess implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignStudiosToPageFailure implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE_FAILURE;
  constructor(public payload: any) {}
}

export class AssignStudiosToPages implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES;
  constructor(public payload: any) {}
}
export class AssignStudiosToPagesSuccess implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignStudiosToPagesFailure implements Action {
  readonly type = ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES_FAILURE;
  constructor(public payload: any) {}
}

export class SendPagesToStudio implements Action {
  readonly type = ProjectActionTypes.SEND_PAGES_TO_STUDIO;
  constructor(public payload: any) {}
}
export class SendPagesToStudioSuccess implements Action {
  readonly type = ProjectActionTypes.SEND_PAGES_TO_STUDIO_SUCCESS;
  constructor(public payload: any) {}
}
export class SendPagesToStudioFailure implements Action {
  readonly type = ProjectActionTypes.SEND_PAGES_TO_STUDIO_FAILURE;
  constructor(public payload: any) {}
}

export class SendManyPagesToStudio implements Action {
  readonly type = ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO;
  constructor(public payload: any) {}
}
export class SendManyPagesToStudioSuccess implements Action {
  readonly type = ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO_SUCCESS;
  constructor(public payload: any) {}
}
export class SendManyPagesToStudioFailure implements Action {
  readonly type = ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO_FAILURE;
  constructor(public payload: any) {}
}


export type All =
  | GetProjects
  | GetProjectsSuccess
  | GetProjectsFailure
  | GetProject
  | GetProjectSuccess
  | GetProjectFailure
  | EditProject
  | CreateProject
  | RetireProject
  | RetireProjectSuccess
  | RetireProjectFailure
  | RestoreProject
  | RestoreProjectSuccess
  | RestoreProjectFailure
  | ShowProjectInfo
  | ShowCopyProject
  | ShowArrangePages
  | AssignOffer
  | AssignOfferSuccess
  | SetProject
  | SetProjectSuccess
  | SetProjectFailure
  | UpdateProject
  | UpdateProjectSuccess
  | UpdateProjectFailure
  | GetPersons
  | GetPersonsSuccess
  | GetPersonsFailure
  | GetDocumentSubTypes
  | GetDocumentSubTypesSuccess
  | GetDocumentSubTypesFailure
  | GetPageLayouts
  | GetPageLayoutsSuccess
  | GetPageLayoutsFailure
  | GetMasterRegionTemplates
  | GetMasterRegionTemplatesSuccess
  | GetMasterRegionTemplatesFailure
  | GetPageBackgrounds
  | GetPageBackgroundsSuccess
  | GetPageBackgroundsFailure
  | GetBusinessBrands
  | GetBusinessBrandsSuccess
  | GetBusinessBrandsFailure
  | GenerateProjectCSV
  | GenerateProjectCSVSuccess
  | GenerateProjectCSVFailure
  | ValidateProject
  | ValidateProjectSuccess
  | ValidateProjectFailure
  | GetStudioPref		
  | GetStudioPrefSuccess		
  | GetStudioPrefFailure
  | GetStudios
  | GetStudiosSuccess
  | GetStudiosFailure
  | AssignStudiosToJob
  | AssignStudiosToJobSuccess
  | AssignStudiosToJobFailure
  | AssignStudiosToPage
  | AssignStudiosToPageSuccess
  | AssignStudiosToPageFailure
  | AssignStudiosToPages
  | AssignStudiosToPagesSuccess
  | AssignStudiosToPagesFailure
  | SendPagesToStudio
  | SendPagesToStudioSuccess
  | SendPagesToStudioFailure
  | SendManyPagesToStudio
  | SendManyPagesToStudioSuccess
  | SendManyPagesToStudioFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/project.actions.ts